import React, { forwardRef, useState } from "react";

// @mui
import FormHelperText from "../mui/FormHelperText";
import LoadingButton from "../mui/LoadingButton";
import { Controller } from "react-hook-form";
import FormControl from "../mui/FormControl";
import Typography from "../mui/Typography";
import TextField from "../mui/TextField";
import Stack from "../mui/Stack";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from "../mui/Box";


// react-router-dom imports
import { useNavigate } from 'react-router-dom';

interface Props {
  control: any;
  errors: any;
  loading: boolean;
  handleSubmit: () => void;
}

const ForgotPassword: React.FC<Props> = forwardRef(
  ({ control, errors, handleSubmit, loading }, ref: any) => {

    const navigate = useNavigate()

    return (
      <Stack>
        <Stack>
            <Box
            onClick={()=>navigate(-1)}
            sx={{
                backgroundColor: "transparent",
                display:"flex",
                boxShadow: "none",
                justifyContent: "flex-start",
                fontWeight: "600",
                padding: "0",
                alignItems:"center",
                gap:"10px",
                cursor:"pointer",

                ":hover":{
                    boxShadow: "none",
                }
            }}
            >
                <ArrowBackIcon />
                Back
            </Box>
          <Typography sx={{ fontWeight: 700, fontSize: "30px", mt: "15px" }}>
            Forgot Password
          </Typography>

          <Typography
            color="textSecondary"
            gutterBottom
            sx={{ fontWeight: 400, fontSize: "14px", marginBottom: "30px" }}
          >
            Enter the email address linked to your account, and we’ll send you a
            link to reset your password.
          </Typography>
        </Stack>
        <Stack sx={{ mb: "20px" }}>

          <Controller
            name="email"
            control={control}
            rules={{
              required: "Email is required",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Enter a valid email address",
              },
            }}
            render={({ field }) => (
              <>
                <Typography sx={{fontWeight:"550" , fontSize:"13px",color:"#2D2D2D"}}>Email address</Typography>
                <FormControl error={!!errors?.email} fullWidth>
                  <TextField
                    type="email"
                    {...field}
                    id="email"
                    ref={ref}
                    placeholder="Enter your email"
                    size="small"
                    fullWidth
                  />
                  <FormHelperText
                    sx={{ marginLeft: "2px", marginBottom: "20px" }}
                  >
                    {errors?.email?.message}
                  </FormHelperText>
                </FormControl>
              </>
            )}
          />
        </Stack>

        <LoadingButton
          onClick={handleSubmit}
          variant="contained"
          sx={{
            textTransform: "capitalize",
            borderRadius: "8px",
            border: "1px solid #a18218",
            backgroundColor: "#fef7da",
            padding: "7px",
            "&:hover": {
              backgroundColor: "#FFF1B7",
            },
            fontWeight:600
          }}
          loading={loading}
          loadingPosition="center"
        >
          {loading ? "Loading" : "Continue"}
        </LoadingButton>
      </Stack>
    );
  }
);

export default ForgotPassword;
